import { CompanyRepresentativeTypes } from "src/contexts/documentationArea/domain/CompanyRepresentativeTypes";

type TranslateFn = (key: string) => string;

export const buildRepresentativeTypeOptions = (t: TranslateFn) =>
  Object.values(CompanyRepresentativeTypes).map((type) => ({
    key: t(`core.input_data_form.company_administrative_type.${type}`),
    value: type,
  }));
